import React from 'react';
import clsx from 'clsx';
import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpInputLine from 'components/molecules/SpInputLine';
import SpSuggestList from 'components/molecules/SpSuggestList';
import TextBox from 'components/atoms/Input/TextBox';
import PulldownInput from 'components/atoms/Input/PulldownInput';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PcSuccessArea from 'components/molecules/PcSuccessArea';
import PcModalBack from 'components/molecules/PcModalBack';

import './index.sp.scss';

const PresentSP = ({
  onClickMainButton,
  handleChangeEkiName,
  modalBackIsEnable,
  handleClickEkiSuggest,
  handleChangeMoveTypeCd,
  handleChangeMoveTime,
  handleChangeMoveTimeFromBusStop,
  moveTypeCdList,
  ekiName,
  searchNames,
  moveTypeCd,
  moveTime,
  moveTimeFromBusStop,
  valid,
  errorDispMap,
  successMessage,
  isApiError, 
  lpMode,
}) => {

  return (
    <div className="StationSp">
      <SpBasicTemplate 
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
        isApiError={isApiError}
        lpMode={lpMode}
      >
        <SpInputLine
          title="就業先の最寄り駅"
        >
          <TextBox
            name="ekiNameForm"
            val={ekiName}
            onChange={handleChangeEkiName}
            placeholder="例) 新橋"
            maxLength="72"
            inValid={!!errorDispMap.ekiName || !!errorDispMap.ekiCd}
          />
          <PcErrorArea position='relative' message={errorDispMap.ekiName || errorDispMap.ekiCd} />
          <PcSuccessArea message={successMessage} />
        </SpInputLine>
        {/* 駅サジェストエリア */}
        <div className="searchNamesWrapper">
          <div className="searchNames">
            <SpSuggestList
              items={searchNames.map(x => x.ekiNm)}
              onClick={handleClickEkiSuggest}
            />
          </div>
        </div>

        <div className="stationTime">
          <SpInputLine title="駅からの所要時間">
            <PulldownInput
              items={moveTypeCdList}
              selectedValue={moveTypeCd}
              onChange={handleChangeMoveTypeCd}
            />
            <span className="textMinutes">
              <TextBox
                name="time"
                val={moveTime}
                onChange={handleChangeMoveTime}
                placeholder="5"
                inValid={!!errorDispMap.moveTime}
                maxLength="3"
              />
              分
            </span>
            <PcErrorArea message={errorDispMap.moveTime} />
          </SpInputLine>
        </div>
        <div className={clsx(
          'selectedBus',
          { bus: moveTypeCd === '2' },
          { other: moveTypeCd !== '2' },
        )}
        >
          <SpInputLine title="バス停からの所要時間">
            <span className="textMinutesFromBusStop">
              徒歩
              <TextBox
                name="timeFromBusStop"
                val={moveTimeFromBusStop}
                onChange={handleChangeMoveTimeFromBusStop}
                placeholder="5"
                inValid={!!errorDispMap.moveTimeFromBusStop}
                maxLength="3"
              />
              分
            </span>
            <PcErrorArea message={errorDispMap.moveTimeFromBusStop} />
          </SpInputLine>
        </div>
        <PcModalBack
          modalBackIsEnable={modalBackIsEnable}
        />
      </SpBasicTemplate>

    </div>
  );
};
export default PresentSP;
